import React from 'react';
import styled from 'styled-components';
import { useMediaQuery } from 'react-responsive';
import { CommonStyledComponentProps } from '__utils/type';
import useFlashToggler from 'hooks/use-flash-toggler';
import { fetchPost } from '__utils/ajax-wrapper';

const MainDiv = styled.div<CommonStyledComponentProps>`
.updatePic{
    color: #00a465;
    cursor: pointer;
}
.floatUpdateDiv{
    display: flex;
    gap:1%;
}

`;

interface FileUploadProps {
    name: string;
    id: string;
    onPictureUpload?: (e: any, shouldSetValue: boolean) => void;
    isUploaded: boolean;
    isCamera?: string;
    children: JSX.Element[] | React.ReactNode;
    style?: React.CSSProperties;
    showAfterUpload?: boolean;
    disabled?: boolean;
    accept: string;
    uploadCallBack?: Function;
    uploadURL?: string;
    onChange?: Function;
    className: string;
    noFileType?: boolean;
    onClick?: Function
}
const FileUpload: React.FC<FileUploadProps> = (props: FileUploadProps) => {
    const isMobile = useMediaQuery({ maxWidth: 767 });
    const flash = useFlashToggler();

    const uploadFile = (file: any) => {
        if (file) {
            if (!(file.type == 'image/jpeg' || file.type == 'image/jpg' || file.type == 'image/png' || file.type == 'image/gif' || file.type == 'image/bmp') || file.size > 5000000) {
                flash.error("Invalid file. You can upload jpeg/jpg/png/bmp/gif file of < 5mb size.");
            }
            else {
                const formData = new FormData();
                formData.append('file', file);
                fetchPost(props?.uploadURL!, formData, null, true
                ).then((response: any) => {
                    if (response.value) {
                        flash.success("File uploaded successfully.")
                        if (props?.uploadCallBack) props?.uploadCallBack(response.value);
                    }
                    else {
                        flash.error("Failed to upload. Please try again later.");
                    }
                }).catch((error: any) => {
                    flash.error("Failed to upload. Please try again later.");
                })
            }
        }

    }

    return (
        <MainDiv isMobile={isMobile}>
            <input
                accept={props.accept}
                onClick={() => props?.onClick && props.onClick()}
                onChange={(e: any) => {
                    if(props?.onChange){
                        props.onChange(e)
                    }
                    if (props?.uploadURL)
                        uploadFile(e.target.files[0]);
                    else
                        if (props?.onPictureUpload)
                            props?.onPictureUpload(e.target.files[0], true);
                }}
                type={ props?.noFileType ?  undefined : "file" }
                name={props.name}
                id={props.id}
                className={props.className}
                capture={props?.isCamera}
                disabled={props?.disabled}
            />
            {(!props.isUploaded || props?.showAfterUpload) &&
                <div
                    style={props?.style}
                    onClick={() => { (document.getElementById(props.id) as HTMLInputElement).click() }}
                >
                    {props.children}
                </div>
            }
        </MainDiv>)
};


export default FileUpload;

